
// region External modules
import $ from "jquery"
import on_domready from "domready"
// endregion External modules

// Private Modules
import DataRetriever from "app/data_retriever"
import WaitObjectByPathPromise from "app/wait_object_by_path_promise"
// Private Modules

import CitiesPublicTransportInfoTable from "concepts/cities/public_transport/info/index"
import {
  default as Buildings_Following_Modal,
  FollowTypes as BuildingFollowTypes,
} from "concepts/buildings/following/modal/index"

import TutorialOverlay from "./components/tutorial_overlay/index"
import SaleListingsBox from "./components/sale_listings_box/index"
import RentalListingsBox from "./components/rental_listings_box/index"
import ExpiredListingsBox from "./components/expired_listings_box/index"

import {
  load_content_and_inject_later as load_below_the_fold_content_and_inject_later,
} from "./below_the_fold_section"



const init = () => {
  if (DataRetriever.get("should-show-follow-prompt")) {
    Buildings_Following_Modal.show(BuildingFollowTypes.COMMERCIAL)
  }
  else {
    TutorialOverlay.init().done()
  }

  SaleListingsBox.init()
  RentalListingsBox.init()

  on_domready(() => {
    const building_id = DataRetriever.get("building-id")

    load_below_the_fold_content_and_inject_later(building_id)
    .then((inject_func) => {
      return WaitObjectByPathPromise("window._spacious_main_css_loaded")
      .then(() => {
        inject_func()

        $(".page-section-title-bar__arrow").on("click", (e) => {
          const $this = $(e.currentTarget)
          $this.parents(".page-section").toggleClass("hide-content")
        })

        ExpiredListingsBox.init()
        CitiesPublicTransportInfoTable.init().done()
      })
    })
  })
}


export default {
  init,
}
